var classes = {"lira-container":"index-module_lira-container__Nwzwo","lira-item":"index-module_lira-item__yrwA6","lira-placeholder":"index-module_lira-placeholder__XIz3d"};

export { classes as default };
//# sourceMappingURL=index.module.scss.js.map
